export default "__VITE_ASSET__d21b3ddf__"